import axios from 'axios';
import { Component } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { setPlaybackPlaylists } from '../../../../redux/actions/app-actions';
import {
  setDisableSkipAheadButton,
  setDisableSkipBackButton,
  setPlayerDocument
} from '../../../../redux/actions/player-actions';
import { default as config } from '../../../../constants/constants';
import { firebase } from '../../../../firebase';
import imageNotAvailable from '../../../../images/image_not_available.png';
import Loader from '../../../../components/Loader';
import Toast from '../../../../components/Toast';
import { Text } from '../../../../components/ui/text/Text';
import Document from './Document';

class Playlist extends Component {
  constructor(props) {
    super(props);
    this.state = {
      documents: [],
      loading: true,
      arranging: false,
      error: null,
      runPlayback: false
      //playerDocument: null
    };
  }

  componentWillMount() {
    if (firebase.auth.currentUser) {
      firebase.auth.currentUser.getIdToken().then((token) => {
        this.fetchDocuments(token);
      });
    }
    if (this.props.playingDocumentId) {
      let playerDocument = this.props.last5ListenedDocuments.find(
        (e) => e.id === this.props.playingDocumentId
      );
      if (playerDocument === undefined) {
        playerDocument = this.props.last5ListenedDocuments.find(
          (e) => e.id === parseInt(this.props.playingDocumentId, 10)
        );
      }
      if (playerDocument !== undefined) {
        playerDocument.document = {
          duration: playerDocument?.duration,
          icon: playerDocument?.imgUrl,
          name: playerDocument?.documentName,
          progress: playerDocument?.progress,
          url: playerDocument?.url
        };
        this.props.dispatch(setPlayerDocument(playerDocument));
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.documentDeleted) {
      const updatedDocuments = this.props.playbackPlaylist.filter(
        (e) => this.props.playerDocument.id !== e.document.id
      );
      this.props.dispatch(setPlaybackPlaylists({ documents: updatedDocuments }));
      //this.setState({ documents: updatedDocuments });
      this.props.onDocumentDeleted(false);
    }
    if (prevProps.playingDocumentId !== null) {
      if (prevProps.playingDocumentId !== this.props.playingDocumentId) {
        this.updatePlayingDocumentProgress();
      }
    }
    if (this.props.playbackPlaylist.length === 0) {
      if (firebase.auth.currentUser) {
        firebase.auth.currentUser.getIdToken().then((token) => {
          this.fetchDocuments(token);
        });
      }
    }
  }

  updatePlayingDocumentProgress() {
    if (this.props.playerDocument) {
      const documentToUpdate = this.props.last5ListenedDocuments.find(
        (e) => e.id === this.props.playerDocument.id
      );
      if (documentToUpdate) {
        const documents = this.props.playbackPlaylist;
        const newDocuments = documents.map((e) => {
          return e.document.id === documentToUpdate.id
            ? { ...e, document: documentToUpdate }
            : e;
        });
        this.props.dispatch(setPlaybackPlaylists({ documents: newDocuments }));
        //this.setState({ documents: newDocuments });
      }
    }
  }

  arrangingHandler = (isArranging) => {
    this.setState({ arranging: isArranging });
  };

  arrangeDocuments = (index, operation) => {
    const documents = this.props.playbackPlaylist;

    if (operation === 'increase') {
      documents[index].ordering = index + 1;
      documents[index + 1].ordering = index;
    } else {
      documents[index].ordering = index - 1;
      documents[index - 1].ordering = index;
    }
    documents.sort((a, b) => a.ordering - b.ordering);

    this.props.dispatch(setPlaybackPlaylists({ documents: documents }));
  };

  fetchDocuments = (token) => {
    return new Promise((resolve, reject) => {
      const { playlist } = this.props;
      const options = {
        method: 'GET',
        headers: { 'X-Firebase-Auth': token },
        url: `${
          config.serverURL
        }/playlists/playlist?playlistName=${encodeURIComponent(
          playlist.name
        )}&includeAll=true`
      };
      axios(options)
        .then((res) => {
          if (res.data) {
            this.props.dispatch(setPlaybackPlaylists({ documents: res.data }));

            this.setState({
              //documents: result.data,
              loading: false
            });
          }
        })
        .catch((err) =>
          this.setState({
            loading: false,
            error: err
          })
        );
    });
  };

  handleDragEnd = (result) => {
    if (!result.destination) return;

    const documents = this.props.playbackPlaylist;
    const [reorderedItem] = documents.splice(result.source.index, 1);
    documents.splice(result.destination.index, 0, reorderedItem);
    const updatedDocuments = documents.map((document, index) => {
      return { ...document, ordering: index };
    });
    this.props.dispatch(setPlaybackPlaylists({ documents: updatedDocuments }));

    this.updateDocumentOrder(updatedDocuments);
  };

  handlePlayDocument = (e) => {
    let isListenNowPlaying = false;
    if (this.props.playlist.name === 'Listen Now') {
      isListenNowPlaying = true;
    }
    this.updatePlayingDocumentProgress();
    this.props.dispatch(setPlayerDocument(e));
    this.props.onPlayDocument(e, isListenNowPlaying, true, false, true, true);
    this.setState({
      runPlayback: false
    });
  };

  updateDocumentOrder = (documentsArray) => {
    if (firebase.auth.currentUser) {
      firebase.auth.currentUser.getIdToken().then((token) => {
        const options = {
          method: 'PUT',
          headers: { 'X-Firebase-Auth': token },
          url: `${config.serverURL}/playlists/`,
          data: { documents: documentsArray }
        };
        axios(options)
          .then(() => {
            return;
          })
          .catch((err) =>
            this.setState({
              error: err
            })
          );
      });
    }
  };

  componentWillUnmount() {
    clearTimeout(this.interval);
  }

  removeError = () => {
    this.interval = setTimeout(() => {
      if (this.state.error) this.setState({ error: null });
    }, 3000);
  };

  runPlayback = () => {
    let isListenNowPlaying = false;
    if (this.props.playlist.name === 'Listen Now') {
      isListenNowPlaying = true;
    }

    this.props.onPlayDocument(
      this.props.playbackPlaylist[0].document,
      isListenNowPlaying,
      true,
      false,
      true
    );

    this.props.dispatch(setDisableSkipAheadButton(false));
    this.props.dispatch(setDisableSkipBackButton(false));
  };

  render() {
    const { playlist, last5ListenedDocuments, playingDocumentId } = this.props;
    if (playingDocumentId !== null) {
      if (last5ListenedDocuments) {
        let playerDocument = last5ListenedDocuments.find(
          (e) => e.id === playingDocumentId
        );
        if (playerDocument === undefined) {
          playerDocument = this.props.last5ListenedDocuments.find(
            (e) => e.id === parseInt(playingDocumentId, 10)
          );
        }
        if (
          this.state.runPlayback &&
          playerDocument &&
          playerDocument.progress >= parseInt(playerDocument.duration, 10) - 1
        ) {
          const documentIndex = this.props.playbackPlaylist.findIndex(
            (e) => e.document.id === playingDocumentId
          );
          let documentToPlayIndex;
          if (documentIndex === this.props.playbackPlaylist.length - 1) {
            documentToPlayIndex = 0;
          } else {
            documentToPlayIndex = documentIndex + 1;
          }
          this.props.onPlayDocument(
            this.props.playbackPlaylist[documentToPlayIndex].document,
            false,
            true,
            false,
            true
          );
        }
      }
    }
    return this.state.loading ? (
      <Loader color="#333367" />
    ) : (
      <DragDropContext onDragEnd={this.handleDragEnd}>
        {this.state.error && (
          <Toast
            type="danger"
            error={this.state.error}
            handleDismiss={this.removeError}
          />
        )}
        <Grid bsClass="">
          <Row>
            <Col xs={3}>
              <div>
                <img
                  src={playlist.imgUrl ? playlist.imgUrl : imageNotAvailable}
                  alt="Image Not Available"
                  width={'100%'}
                  height={'100%'}
                />
              </div>
              <Text color="--color-light-gray">{playlist.name}</Text>
            </Col>
            <Col xs={9} style={{ borderLeft: '1px solid #333' }}>
              <Row style={{ marginBottom: '10px' }}>
                <Col
                  xs={6}
                  style={{
                    display: 'flex',
                    alignItems: 'left'
                  }}
                >
                  <Button
                    bsClass="login-btn button-oval button-cta2-24"
                    style={{ width: 165 }}
                    onClick={this.runPlayback}
                  >
                    FULL PLAYBACK
                  </Button>
                </Col>
                <Col xs={6} style={{ textAlign: 'right' }}>
                  <Button
                    bsClass="login-btn button-oval button-cta2-24"
                    style={{
                      fontWeight: '500',
                      width: 165
                    }}
                    onClick={this.props.goBack}
                  >
                    <i
                      className="fa fa-arrow-left"
                      style={{ marginRight: '5px' }}
                    ></i>
                    PLAYLISTS
                  </Button>
                </Col>
              </Row>
              <Droppable droppableId="documents">
                {(provided) => (
                  <div {...provided.droppableProps} ref={provided.innerRef}>
                    {this.props.playbackPlaylist.map((e, i) =>
                      e.document.id !== undefined ? (
                        <Draggable
                          key={e.document.id}
                          draggableId={e.document.id.toString()}
                          index={i}
                        >
                          {(provided) => (
                            <div
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              ref={provided.innerRef}
                            >
                              <Document
                                document={e}
                                playbackPlaylists={this.props.playbackPlaylist}
                                onFetchDocuments={this.fetchDocuments}
                                onPlayDocument={this.handlePlayDocument}
                                arranging={this.state.arranging}
                                onArrange={this.arrangeDocuments}
                                length={this.props.playbackPlaylist.length - 1}
                                ordering={i}
                              />
                            </div>
                          )}
                        </Draggable>
                      ) : (
                        ''
                      )
                    )}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </Col>
          </Row>
        </Grid>
      </DragDropContext>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    last5ListenedDocuments: store.app.last5ListenedDocuments,
    playerDocument: store.player.playerDocument,
    playbackPlaylist: store.app.playbackPlaylist
  };
};

export default connect(mapStateToProps)(Playlist);
